import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

const Spacer: React.FC<RenderComponentProps> = ({ componentAttributes }) => {
  return <div {...componentAttributes} />;
};

export default Spacer;
